<div class="dalog-header-cust">
  <h2>Contact Support</h2>
  <button
    type="button"
    class="btn-cust-close"
    (click)="navService.openSideNav({ toogle: true })"
  >
    <i class="icon-close"></i>
  </button>
</div>

<div class="side-drawer-content contact">
  <h3>We would love to help you!</h3>
  <div [formGroup]="formGroup" class="px-3 py-1">
    <div class="col-lg-12 col-12">
      <label
        >Message
        @if (Global.isInputRuleAvailable(formGroup, "queryText", "required")) {
          <span class="text-danger">*</span>
        }
      </label>
      <mat-form-field class="w-100">
        <textarea
          matInput
          rows="3"
          formControlName="queryText"
          [class.is-invalid]="!Global.isInputValid(formGroup, 'queryText')"
          placeholder="Type Here"
        >
        </textarea>
        @if (!Global.isInputRuleValid(formGroup, "queryText", "required")) {
          <mat-error>This field is required</mat-error>
        }
        @if (!Global.isInputRuleValid(formGroup, "queryText", "pattern")) {
          <mat-error> Message must not contain only spaces.</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-lg-12 col-12">
      <label
        >Attachment
        @if (
          Global.isInputRuleAvailable(formGroup, "documentData", "required")
        ) {
          <span class="text-danger">*</span>
        }
      </label>
      <div
        class="browse-file"
        [class.is-invalid]="!Global.isInputValid(formGroup, 'documentData')"
      >
        @if (formGroup.value?.documentData) {
          <p>
            {{ formGroup.value?.documentName ?? "File Selected" }}
          
          </p>
          <a matTooltip="Clear" (click)="clear()" class="remove-file"
            ><mat-icon>close</mat-icon></a
          >
        } @else {
          <p>Browse file to upload (MAX 5 MB)</p>
          <input
            accept=".pdf, .xls, .xlsx,.png, .jpeg"
            (change)="
              Global.onFileUploadedToBase64(
                formGroup,
                $event,
                'documentData',
                toastr,
                [
                  'application/pdf',
                  'application/vnd.ms-excel',
                  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  'image/jpeg',
                  'image/png',
                ],
                'documentName',
                [
                  'application/pdf',
                  'application/vnd.ms-excel',
                  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  'image/jpeg',
                  'image/png',
                ]
              )
            "
            type="file"
          />
        }
      </div>
    </div>
    <div class="col-lg-12 col-12 mt-3">
      <label
        >Contact Number
        @if (Global.isInputRuleAvailable(formGroup, "contactNo", "required")) {
          <span class="text-danger">*</span>
        }
      </label>
      <mat-form-field class="w-100">
        <input
          matInput
          formControlName="contactNo"
          [class.is-invalid]="!Global.isInputValid(formGroup, 'contactNo')"
          placeholder="Type Here"
        />
        @if (!Global.isInputRuleValid(formGroup, "contactNo", "required")) {
          <mat-error>This field is required</mat-error>
        }
        @if (!Global.isInputRuleValid(formGroup, "contactNo", "pattern")) {
          <mat-error>Invalid contact number</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-lg-12 col-12">
      <label
        >How critical is your issue is?
        @if (Global.isInputRuleAvailable(formGroup, "issueText", "required")) {
          <span class="text-danger">*</span>
        }
      </label>
      <mat-radio-group
        class="d-block"
        formControlName="issueText"
        color="primary"
      >
        <mat-radio-button class="d-block" value="Nothing, Just FYI"
          >Nothing, Just FYI</mat-radio-button
        >
        <mat-radio-button class="d-block" value="I need to solution ASAP!"
          >I need to solution ASAP!</mat-radio-button
        >
        <mat-radio-button
          class="d-block"
          value="Can wait a bit, nothing to worry"
          >Can wait a bit, nothing to worry</mat-radio-button
        >
      </mat-radio-group>
    </div>
  </div>

</div>
<div class="p-3">
  <div class="d-flex justify-content-end">
    <ng-container
      *ngIf="permissions.hasPermission(claims, 'SETT_VIEW_CONTACT_SUPPORT')"
    >
      <button class="btn btn-outline-primary mx-2" (click)="navigateToList()">
        Request List
      </button>
    </ng-container>
    <button type="button" class="btn btn-primary" (click)="onSubmit($event)">
      <span class="indicator-label"> Send Request</span>
      <span class="indicator-progress"
        >Please wait...
        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
      </span>
    </button>
  </div>
</div>
